import { student } from "../../constants/apiUrl";
import { urlBinder } from "../../helper/url-binder";
import APIService from "../../helper/api-service";
import { IApiResponse } from "../../models/IAPIResponse";
import { IStudentAccountsDetails, IStudentTransactionDetail, IstudentFinanceAccountDetail } from "../../models/student/studentAccountsDetails";

export default new (class StudentAccountService {
    public getAccountsDetails = async (
    ): Promise<IApiResponse<IStudentAccountsDetails>> => {
      try {
        const response = await APIService.get(student.STUDENT_ACCOUNT_DETAIL);
        return response.data as IApiResponse<IStudentAccountsDetails>;
      } catch (error: any) {
        if (error.response) {
          return error.response as IApiResponse<IStudentAccountsDetails>;
        } else {
          throw error;
        }
      }
    };

    public getTransactionDetails = async(
      noOfItems? : number
    ): Promise<IApiResponse<IStudentTransactionDetail>> =>{
      try{
        let endPoint = urlBinder(student.STUDENT_TRASACTION_DETAILS, [`${noOfItems}`]);
        const response = await APIService.get(endPoint);
        return response.data as IApiResponse<IStudentTransactionDetail>;
      }
      catch (error: any) {
        if (error.response) {
          return error.response as IApiResponse<IStudentTransactionDetail>;
        } else {
          throw error;
        }
      }
    };

    public getStudentFinancialAccountDetails = async(
      studentId: string
    ): Promise<IApiResponse<IstudentFinanceAccountDetail>> => {
      try{
        let endPoint = urlBinder(student.STUDENT_FINANCIAL_ACCOUNT_DETAILS, [`${studentId}`]);
        const response = await APIService.get(endPoint);
        return response.data as IApiResponse<IstudentFinanceAccountDetail>;
      } catch(error : any){
        if(error.response){
          return error.response as IApiResponse<IstudentFinanceAccountDetail>;
        }else{
          throw error;
        }
      }
    };

})();